import React from 'react';
import { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import _ from 'lodash';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import IntroB from '../Reponsywne/LewyObiektPelny';
import Animated from '../Zanimowane/Animated';
import AnimatedPLewa from '../Zanimowane/AnimatedP-Lewa';



export default function SekcjaJeden() {
    // predkosci poruszania sie chmur i ksiezyca
    const predkoscTyl = 58;
    const predkoscPrzod = 33;
    const predkoscDruga = 70;
    const [x, setX] = useState(0);
    const [y, setY] = useState(0);
    const [isMobile, setIsMobile] = useState(false);
    const [gamma, setGamma] = useState(0);
    const [beta, setBeta] = useState(0);

    const notify = () => {
        toast.info('Check out my new blog on machine learning! Click here to visit.', {
          position: 'bottom-right', // Use string for position
          autoClose: 10000, // Closes after 5 seconds
          hideProgressBar: false, // Shows progress bar
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          onClick: () => window.location.href = 'https://destray32.github.io/ml-blog/',
        });
      };

    useEffect(() => {
        notify();
        // Sprawdź czy urządzenie ma ekran dotykowy
        const isTouchScreenDevice = () => {
            try {
                document.createEvent('TouchEvent');
                return true;
            } catch (e) {
                return false;
            }
        }

        // Ustaw zmienną isMobile na true lub false
        setIsMobile(isTouchScreenDevice);
    }, []);

    // #region Gyroscope
    const handleDeviceOrientation = (event) => { // funkcja wywolywana przy zmianie orientacji urzadzenia
        const beta = event.beta; // kąt beta
        const gamma = event.gamma; // kąt gamma
        setGamma(gamma);
        setBeta(beta);

        const elementKsiezyc = document.getElementById('gyroscope-ksiezyc');
        const elementyInne = [document.getElementById('gyroscope-chmuraPod1'),
        document.getElementById('gyroscope-chmuraPod2'),
        document.getElementById('gyroscope-chmuraNad1'),
        document.getElementById('gyroscope-chmuraNad2'),
        document.getElementById('gyroscope-napisPort'),
        document.getElementById('gyroscope-moonlight')];

        if (elementKsiezyc) {
            elementKsiezyc.style.transform = `translate(${-(gamma / 2)}px, ${-(beta / 2)}px)`;
        }
        elementyInne.forEach(element => {
            element.style.transform = `translate(${-(gamma / 8)}px, ${-(beta / 4)}px)`;
        });

    };

    useEffect(() => { // hook wywolywany przy zamontowaniu komponentu

        window.addEventListener('deviceorientation', handleDeviceOrientation); // nasluchujemy na zmiane orientacji urzadzenia

        return () => { // funkcja wywolywana przy odmontowaniu komponentu
            window.removeEventListener('deviceorientation', handleDeviceOrientation); // usuwamy nasluchiwanie na zmiane orientacji urzadzenia
        };
    }, []); // pusta tablica oznacza ze hook wywola sie tylko raz
    // #endregion

    // #region Poruszanie obrazkiem
    useEffect(() => {
        const handleMouseMove = (event) => {
            setX(event.clientX);
            setY(event.clientY);
        };

        document.addEventListener('mousemove', handleMouseMove);

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);
    // #endregion

    const { ref, inView } = useInView(); // hook zwracajacy referencje do elementu i boolean czy jest w widoku

    return (
        <>
        <ToastContainer />
            <div id="sekcjaJeden-wrapper" className='flex ' ref={ref}>

                <div className='absolute top-[25rem] md:static tall:top-[45rem]'>
                    <Animated referencja={inView} czyZanimowane={true}> { /* komponent który animuje swoje dzieci */}
                        <IntroB tytul={"Jakub Bednarek"} fontSize={85} refer={inView} czyZanimowane={true}>
                            <p className='font-sen text-[25px] tracking-widest text-white'>Software engineer / Data Scientist</p>
                        </IntroB>
                    </Animated>
                </div>


                <div> {/* Kontener z ksiezycem */}
                    <div id='ksiezyc-kontener' className=' tall:top-[15%] tall:scale-50 tall:left-[-61%]
                                                        tallBig:top-[19%]
                                                        absolute top-[-5%] bottom-0 left-[-87%] h-[485px] w-[1385px] 
                                                        select-none scale-[35%]
                                                        sm:top-[0%] sm:left-[45%] sm:scale-[80%]
                                                        md:top-[0%] md:left-[45%] md:scale-[90%]
                                                        2xl:top-[0%] 2xl:left-[55%] 2xl:scale-100
                                                        -z-50'> {/* zmieniajac ksiezyc-kontener (top bottom itp) zmieniamy położenie całej grafiki z księżycem */}
                        <div className=' relative w-[50%] h-[50%]'>

                            <AnimatedPLewa referencja={inView} dlugoscAnimacji={2}>
                                <div id='ksiezyc' className='relative left-[3rem] bottom-[-4.5rem] z-30'>
                                    <img id='gyroscope-ksiezyc' src="ksiezyc.svg" alt="ksiezyc" className=' w-[85%] ' style={(isMobile === false) ? { transform: `translate3d(${-(x - window.innerWidth / 2) / predkoscDruga}px, ${-(y - window.innerHeight / 2) / predkoscDruga}px, 0)` } : {}} />
                                </div>
                            </AnimatedPLewa>


                            <div id='chmura1-pod' className=' absolute block left-[-15rem] top-[-13rem] -z-10'>
                                <AnimatedPLewa referencja={inView} dlugoscAnimacji={1.5}>
                                    <div id='gyroscope-controlled-element' className=' bottom-[-18%] right-[-29%]' style={(isMobile === false) ? { transform: `translate3d(${-(x - window.innerWidth / 2) / predkoscTyl}px, ${-(y - window.innerHeight / 2) / predkoscTyl}px, 0)` } : {}}>
                                        <img id='gyroscope-chmuraPod1' src="chmura2.svg" alt="chmura" className='w-[600px] invert-[.90] opacity-40' />
                                    </div>
                                </AnimatedPLewa>
                            </div>

                            <div id='chmura4-pod' className=' absolute block left-[24rem] top-[-5rem] w-[500px] -z-10'>

                                <AnimatedPLewa referencja={inView} dlugoscAnimacji={1.5}>
                                    <div id='gyroscope-controlled-element' className=' bottom-[-18%] right-[-29%]' style={(isMobile === false) ? { transform: `translate3d(${-(x - window.innerWidth / 2) / predkoscTyl}px, ${-(y - window.innerHeight / 2) / predkoscTyl}px, 0)` } : {}}>
                                        <img id='gyroscope-chmuraPod2' src="chmura4.svg" alt="chmura" className='gyroscope-inne w-[400px] invert-[.90] opacity-40' />
                                    </div>
                                </AnimatedPLewa>
                            </div>


                            <div id='chmura2-nad' className=' absolute block left-[-10.5rem] top-[11rem] z-50'>
                                <AnimatedPLewa referencja={inView} dlugoscAnimacji={1.1}>
                                    <div id='gyroscope-controlled-element' className=' bottom-[-18%] right-[-29%]' style={(isMobile === false) ? { transform: `translate3d(${-(x - window.innerWidth / 2) / predkoscPrzod}px, ${-(y - window.innerHeight / 2) / predkoscPrzod}px, 0)` } : {}}>
                                        <img id='gyroscope-chmuraNad1' src="chmura1.svg" alt="chmura" className='gyroscope-inne w-[80%]' />
                                    </div>
                                </AnimatedPLewa>
                            </div>
                            <div id='chmura3-nad' className=' absolute left-[17rem] top-[8rem] w-[500px] z-50'>
                                <AnimatedPLewa referencja={inView} dlugoscAnimacji={1.3}>
                                    <div id='gyroscope-controlled-element' className=' bottom-[-18%] right-[-29%] opacity-100' style={(isMobile === false) ? { transform: `translate3d(${-(x - window.innerWidth / 2) / predkoscPrzod}px, ${-(y - window.innerHeight / 2) / predkoscPrzod}px, 0)` } : {}}>
                                        <img id='gyroscope-chmuraNad2' src="chmura1.svg" alt="chmura" className='gyroscope-inne' />
                                    </div>
                                </AnimatedPLewa>
                            </div>
                            <div id='moonlight' className='absolute left-[-21.8rem] top-[-16rem] -z-[100]'>
                                <div id='gyroscope-controlled-element' className='bottom-[-18%] right-[-29%] w-[200%]' style={(isMobile === false) ? { transform: `translate3d(${-(x - window.innerWidth / 2) / predkoscDruga}px, ${-(y - window.innerHeight / 2) / predkoscDruga}px, 0)` } : {}}>
                                    <img id='gyroscope-moonlight' src="moonlight.svg" alt="moonlight" className='gyroscope-inne' />
                                </div>
                            </div>
                            <div id='gwiazdy' className='absolute left-[-25.8rem] top-[-25rem] -z-[150] w-[1500px]'>
                                <div id='gyroscope-controlled-element' className='bottom-[-18%] right-[-29%] w-[100%]' style={(isMobile === false) ? { transform: `translate3d(${-(x - window.innerWidth / 2) / predkoscDruga}px, ${-(y - window.innerHeight / 2) / predkoscDruga}px, 0)` } : {}}>
                                    <img id='' src="gwiazdy.svg" alt="gwiazdy" className='gyroscope-inne w-[1200px] rotate-[53deg]' />
                                </div>
                            </div>
                            <div id='portfolio-napis' className='absolute left-[0rem] top-[23rem] w-[500px] z-[9999]'>
                                <AnimatedPLewa referencja={inView} dlugoscAnimacji={1.8}>
                                    <div id='gyroscope-napisPort' style={(isMobile === false) ? { transform: `translate3d(${-(x - window.innerWidth / 2) / 55}px, ${-(y - window.innerHeight / 2) / 55}px, 0)` } : {}} className=' bottom-[-18%] right-[-29%] w-[100%]
                                 text-red-500 text-[50px] tracking-[.22em] font-extrabold drop-shadow-[0_09px_09px_rgba(0,0,0,0.5)]'>PORTFOLIO</div>
                                </AnimatedPLewa>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}